<script>
    import LySection from './LySection.svelte';

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     padding?: boolean | string,
     *     rounded?: boolean | string,
     *     bg?: boolean | string,
     *     border?: boolean | string,
     *     shadow?: boolean | string,
     *     wrapper?: boolean | string,
     *     center?: boolean | string,
     *     addClass?: string,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let {
        tag = 'section',
        mt = 0,
        mb = 0,
        padding = true,
        rounded = true,
        bg = 'black-50',
        border = true,
        shadow = true,
        wrapper = false,
        center = false,
        addClass = '',
        children,
    } = $props();
</script>

<LySection {tag} {mt} {mb} {padding} {rounded} {bg} {border} {shadow} {wrapper} {center} {addClass}>
    {@render children?.()}
</LySection>
